module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#logout",
      toString: function () {
        return this.url;
      }
    }